import * as Long from "long";
import { of } from "rxjs";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionPlayerLeagueInfoSetPoints } from "../../info/league/actionPlayerLeagueInfo";
export var networkNoticeUpdateCollectLeagueEventHandler = function (action$) { return function (res, state$) { return of(actionPlayerLeagueInfoSetPoints(res.points || Long.ZERO, EventType.CollectLeague)); }; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeUpdateCollectLeagueEventHandler.ts
// module id = 2018
// module chunks = 3